export default {
  "translation": {
    "card_application": "Card Application",
    "card_application_des": "Get a Sonic card and use it at 44M+ Visa-enabled merchants globally.",
    "spend_your_crypto_like_fiat": "Spend your crypto like fiat",
    "use_globally_across_borders": "Use it globally, across borders",
    "ultra_low_trans_costs": "Ultra-low costs",
    "seamless_and_secure": "Seamless and Secure",
    "two_factor_verification": "Two-factor Authentication",
    "two_factor_verification_des": "Login securely using email, phone, biometrics, and/or authenticator app",
    "safety_pin": "Safety PIN",
    "safety_pin_des": "Restrict access to private info by setting up a PIN",
    "trans_3ds_verification": "3DS Verification",
    "trans_3ds_verification_des": "Authorize purchases before they're processed",
    "additional_security": "Additional Security",
    "additional_security_des": "Easily set up card limits and other security features on the app",
    "get_your_redotpay_card_in_steps": "Get your Sonic card in 3 steps.",
    "get_your_redotpay_card_subtitle": "Chosen by 44M+ users. Crypto can be used like fiat.",
    "continue_key": "Continue",
    "bind_your_mobile_number": "Bind your Mobile Number",
    "complete_identity_verification": "Complete the identity verification",
    "apply_a_virtual_or_physical_card": "Apply for a virtual card",
    "transactions": "Transactions",
    "need_mobile_bind_confirm": "Need to bind Mobile first",
    "info": "Info",
    "card_trans_status_refund_pending": "Refund Pending",
    "card_trans_status_refund_success": "Refund Successful",
    "card_trans_status_refund_fail": "Refund Failed",
    "card_trans_status_refund_wait": "Refund Waiting",
    "card_trans_status_pending": "Authorized",
    "card_trans_status_cleared": "Cleared",
    "card_trans_status_declined": "Declined",
    "card_trans_status_canceled": "Reversed",
    "card_trans_status_refund": "Refund",
    "card_trans_status_refund_cancel": "Refund Cancel",
    "refund": "Refund",
    "transaction_list": "Transaction List",
    "more": "More",
    "top_questions": "Top Questions",
    "faq": "FAQ",
    "self_service": "Self Service",
    "support_center": "Support Center",
    "hello": "Hello",
    "updated_on": "Updated On",
    "chat_with_us": "Chat With Us",
    "warning": "Warning",
    "security_option_change_alert_prompt": "After unbind/modify Google Authenticator/mobile/email/PIN, withdrawal and internal transfer will be disabled and card transactions will be limited to $1000 per transaction within the next 24 hours for security reasons.",
    "cancel": "Cancel",
    "ok": "OK",
    "account_deletion_regret_promp": "Account deletion allows you a 15-day regret period. When you login again within 15 days after you apply for deletion, your application will be cancelled, and your account can continue to be used normally.",
    "view_on_blockchain_explorer": "View on blockchain explorer",
    "biz_sn": "Transaction Number",
    "type": "Type",
    "create_time": "Create Time",
    "logout_confirm": "Are you sure you want to logout?",
    "wallet": "Wallet",
    "continue_with_google": "Continue with Google",
    "insufficient_balance_deposit_guide": "Insufficient balance. Deposit assets or your transactions will be declined and a fee may be charged.",
    "to": "To",
    "bill_will_be_sent_to": "Bill statement will be sent to",
    "bill_statement": "Bill Statement",
    "export_bill": "Export Bill Statement",
    "this_month": "This Month",
    "last_month": "Last Month",
    "last_3_month": "Last 3 Months",
    "this_year": "This Year",
    "last_year": "Last Year",
    "customize": "Customize",
    "bill_export_success": "The bill statement has been sent to your email, please check",
    "bill_empty": "Your bill is empty",
    "channel": "Channel",
    "merchant_country": "Merchant Country",
    "status": "Status",
    "withdraw_detail": "Widthdraw Details",
    "new_key": "New",
    "deposit": "Deposit",
    "withdraw": "Withdraw",
    "single_limit": "Single Limit",
    "all": "ALL",
    "minimum": "Minimum",
    "available": "Available",
    "received_amount": "Received Amount",
    "withdrawl": "Withdraw",
    "network_fee": "Network Fee",
    "register": "Register",
    "register_login": "Register/Login",
    "login": "Login",
    "email_Phone": "Email/Phone Number",
    "email": "Email",
    "mobile": "Mobile",
    "next": "Next",
    "or_continue_with": "Or continue with",
    "forgot_pw": "Forgot your password?",
    "welcome_to_redotpay": "Welcome To Sonic Pay",
    "verify_code": "Verify Code",
    "get_code": "Get code",
    "by_creating_an_account": "By creating an account you agree to our",
    "privacy_policy": "policy",
    "terms_conditions": "Terms & Conditions",
    "and": "and",
    "modify_pin": "Change PIN",
    "pin_subtitle": "The security PIN provides quick verification, making it easy for you to view card numbers and CVV information.",
    "password_set_first_login": "First login to set password",
    "next_step": "Next Step",
    "confirm": "Confirm",
    "username": "Username",
    "password": "Password",
    "send_code": "Send Code",
    "send_code_to": "Code will be sent to",
    "switch_option": "Change Verification Option",
    "mobile_verification": "Mobile Verification",
    "email_verification": "Email Verification",
    "choose_verify_method": "Change Verification Option",
    "verify_pin": "Security PIN",
    "google_authenticator_verification": "Google Authenticator",
    "security": "Security",
    "bound": "Bound",
    "unbound": "UnBound",
    "set": "Set",
    "unset": "UnSet",
    "update_pw": "Change Password",
    "delete_account": "Cancel Account",
    "google_authenticator": "Google Authenticator",
    "google_authenticator_subtitle": "Google Authenticator protects your withdrawals and account.",
    "download_install": "Download",
    "download_install_prompt": "First you need download and install the Authenticator app（Google Authenticator）",
    "backup_key": "Backup key",
    "save_backup_key": "Save this backup key in a secure location",
    "google_authenticator_code": "Google Authenticator Code",
    "email_subtitle": "Email verification protects your withdrawals and account.",
    "change_email": "Change Email",
    "email_update": "Email Update",
    "code": "Code",
    "mobile_subtitle": "Mobile verification protects your withdrawals and account.",
    "change_mobile": "Change Mobile",
    "mobile_update": "Mobile Update",
    "mobile_bind": "Bind Mobile Phone",
    "email_bind": "Bind Email",
    "old_password": "Old Password",
    "new_password": "New Password",
    "new_password_confirm": "New Password Confirm",
    "language": "Language",
    "appearance": "Appearance",
    "logout": "Logout",
    "log_out_toast": "You have been logged out",
    "set_pin": "Security PIN",
    "account_deletion_prompt_1": "This action is irreversible",
    "account_deletion_prompt_2": "All sub-users / other accounts created by this account will be deleted and cannot be retrieved.",
    "account_deletion_prompt_3": "All API keys associated with this account will be deleted.",
    "account_deletion_prompt_4": "All current delegated and pending currency withdrawals of this account will be cancelled.",
    "account_deletion_prompt_5": "All transaction functions of this account will be disabled.",
    "account_deletion_prompt_6": "Assets not withdrawn from this account will be regarded as assets voluntarily abandoned.",
    "account_deletion_prompt_7": "After you delete an account application, you can have a 15-day withdrawal period. When you log in again within 15 days after the deletion request, your deletion request will be canceled and the account can continue to be used normally.",
    "kyc_status_0": "Not Submitted",
    "kyc_status_1": "Verifying...",
    "kyc_status_2": "Approved",
    "kyc_status_3": "Audit Failed",
    "kyc_status_4": "Resubmitted",
    "kyc_status_5": "Submit To Upstream",
    "personal_info_review": "Personnel Info Review",
    "additional_info_request": "Additional info request",
    "verifying": "Verifying...",
    "form_submitted_will_review_asap_new": "Your application has been submitted for manual review. The process usually takes 3-5 days, but may occasionally take longer. Please be patient.",
    "get_verified": "Identity Verification",
    "kyc_verified": "User Identity Verified",
    "approved": "Approved",
    "not_able_to_submit_identity": "As part of our comprehensive review process, we require additional information from you to complete the Know Your Customer (KYC) and Anti-Money Laundering (AML) screening procedures.",
    "aml_review_failed": "To proceed with your application, please click on the button below to access and complete the Self Declaration form.",
    "aml_declaration_prompt": "Please note that failure to provide the requested form within the next 14 days result in the decline of your application.",
    "verify_your_identity": "Verify your identity",
    "get_identity_verified": "Get your identity verified to buy and use the card",
    "country_region": "Country/Region",
    "given_name": "Given name",
    "surname": "Surname",
    "date_of_birth": "Date Of Birth",
    "document_type": "Document Type",
    "document_number": "Document Number",
    "given_name_intl": "Given Name(INTL)",
    "surname_intl": "Surname(INTL)",
    "click_to_add_signature": "Click to add signature",
    "rewrite": "Rewrite",
    "submit": "Submit",
    "save": "Save",
    "accounts_are_not_available": "Accounts are not available",
    "abandon_assets": "Abandon {{amount}} {{currency}} assets",
    "account_deletion_successful": "Account deletion successful",
    "passwords_do_not_match": "Passwords do not match",
    "password_reset_success": "Password reset successful",
    "password_confirm": "Password Confirm",
    "is_refund": "Refund",
    "total_debt": "Total Debt",
    "your_account_is_in_arrears": "Your account is in arrears. Please deposit sufficient funds to settle the balance. Your account/card will be restored when your balance is ≥10 USD after debt repayment.",
    "repayment": "Repayment",
    "debit_record": "Debit Record",
    "no_data": "Empty Data",
    "payment": "Payment",
    "transaction_details": "Transaction Details",
    "transaction_date": "Transaction Date",
    "transaction_id": "Transaction ID",
    "view_linked_order": "View Linked Order",
    "rights_interests": "Rights & Interests",
    "transaction_limit": "Transaction Limit",
    "deposit_withdraw": "Deposit & Withdraw",
    "card_purchased_number": "Number of cards available for purchase",
    "on_review_your_applicant": "We are reviewing your application",
    "form_en_only": "The form can only be filled in English",
    "available_to_spend": "Available to spend",
    "get_a_card": "Get a Sonic card and use it at 44M+ Visa-enabled merchants globally.",
    "virtual_card": "Virtual Card",
    "physical_card": "Physical Card",
    "apply_card": "Apply Card",
    "enjoy_seamless_spending": "Spend",
    "spend_and_withdraw": "Spend & ATM withdrawal",
    "card_labeling": "Card Labeling",
    "card_tag": "Card Tag",
    "edit_billing_address": "Billing Address",
    "government_issued_id": "Government-issued ID",
    "facial_recognition": "Facial Recognition",
    "address": "Address",
    "personnel_information_details": "Personnel Information Details",
    "nation_list": "Nation List",
    "choose_channel": "Verification Mode",
    "mobile_channel_sms": "SMS",
    "mobile_channel_smsAliyunWhatsApp": "WhatsAPP",
    "card_application_order": "Card Application Order",
    "promo_code_optional": "Promo Code (Optional)",
    "promo_code": "Promo Code",
    "billing_address": "Billing Address",
    "shipping_address": "Shipping Address",
    "shipping_to": "Shipping To",
    "card_purchase_fee": "Card Application Fee",
    "card_holder_name": "Card Holder Name",
    "city": "City",
    "province_state": "Province/State",
    "postal_code": "Postcode/ZIP",
    "address_line1": "Address",
    "address_line2": "Address Line 2",
    "please_fill_in_the_information_in_english": "The form can only be filled in English",
    "first_name": "First Name",
    "last_name": "Last Name",
    "country_code": "Country Code",
    "card_application_list": "Card Application List",
    "buy_virtual_card": "Buy Virtual Card",
    "buy_physical_card": "Buy Physical Card",
    "withdraw_list": "Withdraw List",
    "no_more_data": "No More Data",
    "select_a_network": "Select a network",
    "please_select_network": "Please select a network",
    "select_a_network_ensure": "Ensure the network you choose to deposit matches the withdrawal network,or assets may be lost.",
    "network": "Network",
    "card_management": "Card Management",
    "freeze": "Freeze",
    "unfreeze": "Unfreeze",
    "freeze_card_des": "Once the one-key card lock function is enabled, you will not be able to use this card, but it will not affect other cards. If you want to cancel the one-key card lock function, you can enable it here again",
    "freezing_trades": "Freezing a card produces a failed order, Causing transaction failure or additional fees for declined trades",
    "unfreeze_your_card_desc": "Once the one-key card lock function is disabled, you will be able to use this card again, and it will not affect other cards. If you want to freeze the card, you can do it here again",
    "card_tag_set_success": "Card tag set successfully",
    "bill": "Bill",
    "setting": "Settings",
    "limit": "Limits",
    "assets_list": "Assets List",
    "empty_data": "Empty Data",
    "deposit_list": "Deposit List",
    "date": "Date",
    "merchant_city": "Merchant City",
    "card_number": "Card Number",
    "card_type": "Card Type",
    "mcc": "MCC",
    "declined_reason": "Declined Reason",
    "card_authorization_payment": "Card Authorization Payment",
    "declined_transaction_fee": "Declined Transaction Fee",
    "verified": "Verified",
    "notifications": "Notifications",
    "need_to_add_bill_address": "Billing address cannot be empty",
    "need_to_add_shipping_address": "Shipping address cannot be empty",
    "success": "Success",
    "welcome_redotpay": "Welcome to Sonic Pay!",
    "reset_pw_alert": "After changing your password, withdrawal and internal transfers will be disabled, and card transactions will be limited to $1000 per transactions for the following 24 hours",
    "no_more_records": "No More Records",
    "add": "Add",
    "address_label": "Address Label",
    "add_address": "Add Address",
    "this_field_is_required": "This field is required",
    "ID_CARD": "ID Card",
    "PASSPORT": "Passport",
    "DRIVERS": "Driving License",
    "RESIDENCE_PERMIT": "Residence Permit",
    "amount": "Amount",
    "withdraw_status_waiting": "Waiting",
    "withdraw_status_pending": "Pending",
    "withdraw_status_success": "Success",
    "withdraw_status_fail": "Fail",
    "withdraw_status_canceled": "Canceled",
    "withdraw_status_declined": "Declined",
    "withdraw_status_complete": "Complete",
    "order_id": "Order ID",
    "click_or_scroll_to_load_more": "Click or scroll to load more",
    "minimum_deposit_amount": "Minimum Deposit Amount",
    "deposit_arrival_confirmations": "Deposit arrival: {{confirmations}} confirmations",
    "confirmations": "{{confirmations}} Confirmations",
    "deposit_network": "Deposit Network",
    "minimum_deposit": "Minimum Deposit",
    "deposit_arrival": "Deposit Arrival",
    "current_address_supports_depositing": "The current address only supports depositing {{varietyCode}} on {{displayName}}, and other assets will be lost.",
    "copy_successful": "Copy Successful",
    "update_password_successful": "Update Password Successful",
    "update_successful": "Update Successful",
    "successful": "Successful",
    "signature_required": "Signature Required",
    "deposit_successful": "Deposit Successful",
    "sign_out": "Log Out",
    "cancel_withdraw_order_success": "Withdrawal Order Cancellation Successful",
    "delete_successful": "Deletion Successful",
    "unfreeze_card_successful": "Unfreeze Card Successful",
    "card_nickname_set_success": "Card Nickname Set Successful",
    "trans_limit_adjusted_success": "Transaction Limit Adjusted Successfully",
    "set_card_pin_success": "Set Card PIN Successful",
    "withdraw_apply_commit_please_wait": "Withdrawal application submitted, please wait",
    "unfreeze_success": "Unfreeze Successful",
    "freeze_success": "Freeze Successful",
    "withdraw_duration_tip": "Withdrawal applications will be processed within one business day",
    "you_will_withdraw": "You withdraw",
    "withdraw_info": "Withdraw Info",
    "please_confirm_same_network": "Ensure the network you choose to deposit matches the Deposit network,or assets may be lost.",
    "cancel_withdraw_order_confirm": "Are you sure you want to cancel the withdrawal?",
    "valid_thru": "valid until",
    "last_7_days": "Last 7 Days",
    "last_30_days": "Last 30 Days",
    "today": "Today",
    "all_done": "All Done",
    "view_details": "View Details",
    "withdraw_success": "Withdrawal Successful",
    "pay": "Pay",
    "fee": "Fee",
    "discount": "Discount",
    "price": "Price",
    "card_application_details": "Card Application Details",
    "card_pin": "Card PIN",
    "card_pin_format_helper": "Cannot contain three consecutive identical numbers or sequential numbers",
    "digit_variable": "{{count}} digit",
    "address_book": "Address Book",
    "unlimited": "Unlimited",
    "single": "Single",
    "update_card_pin": "Update Card PIN",
    "set_card_pin": "Set Card PIN",
    "report_lost": "Report Lost",
    "report_lost_card": "Report lost card",
    "card_lost_report_alert": "After reporting lost, the card will be deactivated and you will not be able to change the status. If you wish to use the card again or apply for a new card, please contact customer service team. ",
    "pending": "Pending",
    "frozen": "Frozen",
    "phone_number": "Phone Number",
    "search": "Search",
    "reset": "Reset",
    "total_amount": "Total Amount",
    "actual_amount": "Actual Amount",
    "already_have_an_account": "Already Have an Account?",
    "create_account": "Create a Sonic Pay account",
    "total_balance": "Total Balance",
    "cards_balance_available_promp": "Credit limit calculated in real time based on wallet assets",
    "got_it": "Got it",
    "review_details": "Review Details",
    "delete_this_address": "Delete This Address?",
    "currency": "Currency",
    "merchant_name": "Merchant Name",
    "request_time": "Request Time",
    "is_transaction_allowed": "Is this transaction allowed?",
    "approve": "Approve",
    "decline": "Decline",
    "card_in_production": "Card In Production",
    "redotpay_card_sent": "Redotpay Card Sent",
    "redotpay_card_activated": "Redotpay Card Activated",
    "activate_card": "Activate Card",
    "paste": "Paste",
    "fees_included": "Fees Included",
    "fx_fee": "FX Fee",
    "small_auth_fee": "Small Transaction Fee",
    "atm_fee": "ATM Fee",
    "received": "Received",
    "incremental": "Incremental",
    "bill_address_save_success": "bill address save success",
    "no_more_trans_record": "No more transaction records",
    "withdraw_amount_larger_than_available": "Exceeds maximum available balance",
    "withdraw_lower_than_min": "Below minimum withdrawal amount",
    "card_is_deleted": "Card Is Deleted",
    "something_error": "Something went wrong",
    "home": "Home",
    "select_country": "Select Country",
    "billing_list": "Billing List",
    "coupon_code": "Discount Code",
    "password_rule1": "8 to 32 characters",
    "password_rule2": "At least one English capital letter ",
    "password_rule3": "At least one lowercase letter",
    "password_rule4": "At least one number",
    "set_pw": "Set Password",
    "payment_currency_settings": "Payment Currency Settings",
    "customize_payment_currency": "Customize Payment Currency",
    "disable_non_local_tip": "Disabling non-local currency transactions can effectively reduce the risk of card fraud",
    "charging_rules": "Charging Rules",
    "reissue_card": "Reissue Card",
    "update_cvv": "Update CVV",
    "update_cvv_desc": "Same card number, new CVV and expiry date.",
    "reissue_fee": "Reissue Fee",
    "fx_fee_desc": "Foreign Exchange Fee (FX Fee) include 1.2% Non-default currency transaction.(if applicable)",
    "atm_fee_desc": "An additional fee of 2% will be charged for each ATM withdrawal.",
    "remit_fee_desc": "Fees for Using a Visa Credit or Debit Card",
    "risk_safety_tips": "Safety Tips",
    "risk_safety": "For security reasons, Please complete the facial recognition verification on the app before proceeding with any related operations.",
    "go_to_app_verify": "Go to App to Verify",
    "register_download_app_title": "Sonic card service is ending. If you're a Sonic cardholder, you can get a free virtual card when you switch to RedotPay.",
    "register_download_app_desc": "Starting today, new registrations for the Sonic card, card issuance, and deposits are no longer available.\n\nFrom <bold>September 15, 2026</bold>, Sonic cards can no longer be used for transactions.\n\nWe've arranged so that you can continue your card services with RedotPay. <bold>Just register using the same email address linked to your Sonic account.</bold>\n\nIf you have a Sonic card, you'll get a free virtual RedotPay card once the move is complete.",
    "get_your_free_card": "Get your free card",
    "register_download_app_title_ended": "Sonic card services have now moved to RedotPay. If you're a Sonic cardholder, you can get a free virtual card when you register with RedotPay.",
    "register_download_app_desc_ended": "Starting today, new registrations for the Sonic card, card issuance, and deposits are no longer available.\n\nFrom <bold>September 15, 2026</bold>, Sonic cards can no longer be used for transactions.\n\nWe've arranged so that you can continue your card services with RedotPay. <bold>Just register using the same email address linked to your Sonic account.</bold>\n\nIf you have a Sonic card, you'll get a free virtual RedotPay card once the move is complete.",
    "go_to_redotpay": "Go to RedotPay",
    "go_to_redotpay_now": "Go to RedotPay Now",
    "close": "Close",
    "card_cancellation": "Card Cancellation",
    "delete_card": "Delete Card",
    "delete_card_desc": "The card will be unusable after deletion, and this action is irreversible.",
    "deleting_fee": "Deletion Card Fee",
    "delete": "Delete",
    "currency_tips": "Tips",
    "at_least_one_currency": "Please keep at least one payable currency.",
    "all_select_currency": "You already support all currencies to complete transactions.",
    "small_auth_transaction_fee_stas": "Small Transaction Fee Details",
    "small_transactions_this_month": "Small transactions this month",
    "small_autn_trans_remain": "Number of fee-exempted small transactions this month",
    "rules": "Rules",
    "failed_rules": "Failed transactions will increase the number of poor transaction records, and additional fees will be added if you exceed them. Please regulate the transaction.",
    "rule_item": "Item",
    "free_count": "Free Count",
    "fees": "Fees",
    "declined_trans_remain": "Number of fee-exempted declined transactions this month",
    "declined_transaction_fee_stats": "Declined Transaction Fee Stats",
    "declined_rules": "Failed transactions will increase the number of poor transaction records, and additional fees will be added if you exceed them. Please regulate the transaction.",
    "declined_transactions_this_month": "Number of declined transactions this month",
    "card_trans_detail_status_refund": "Refund processing",
    "card_trans_status_reversal": "Reversal",
    "card_trans_status_fully_refund": "Processed, full refund issued",
    "card_trans_status_partial_refund": "Processed, partial refund issued",
    "card_trans_status_void": "Void",
    "first_time_free": "Free for the first time",
    "FxFee": "Foreign Exchange Fee",
    "AtmFee": "ATM Fee",
    "RemitFee": "Remittance Fee",
    "MccFee": "Mcc Fee",
    "SmallAuthFee": "Small Auth Fee",
    "mcc_fee_desc": "Some merchants will charge an additional fee of 1.5% of the transaction amount. If the fee is less than 0.5 USD, a minimum fee of 0.5 USD will be applied.",
    "please_deposit": "Please Deposit",
    "special_mcc_fee": "Special Mcc Fee",
    "bank_verifying": "This refund is being reviewed by the bank…",
    "estimate_time": "Estimated time to arrive: 2-30 days",
    "delete_out": "Delete",
    "card_is_loss": "The card has been reported lost",
    "incremental_desc": "Additional fees may occur if the authorized amount is insufficient. The settlement amount of the order is based on the actual consumption amount.",
    "card_trans_status_fully_refund1": "Cleared",
    "card_trans_status_fully_refund2": "Fully Refunded",
    "card_trans_status_partial_refund1": "Cleared",
    "card_trans_status_partial_refund2": "Partially Refunded",
    "review_takes_time": "Review takes 2 minutes to 24 hours.",
    "custom_date_null": "Please select a custom date",
    "custom_date_error": "Please set the correct query time",
    "small_trade_fee": "Small Transaction",
    "user_risk_exception": "User Status Exception",
    "request_exception": "Request Error",
    "mobile_is_not_empty": "Please enter a valid mobile number",
    "code_is_not_empty": "Please enter a valid verification code",
    "browser_paste_error": "Browser restrictions, please enter manually"
  }
};